import ProPlan from './ProPlan';

export default ProPlan;
